import { Route } from '@angular/router'

import {
  AuthGuard,
  PermissionGuard,
  ResourceMode
} from '@case-app/angular-library'

import { InvoiceCreateEditComponent } from './invoice-create-edit/invoice-create-edit.component'
import { InvoiceListComponent } from './invoice-list/invoice-list.component'

export const invoiceRoutes: Route[] = [
  {
    path: 'factures',
    component: InvoiceListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseInvoices'
    }
  },
  {
    path: 'factures/create',
    component: InvoiceCreateEditComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'addInvoices',
      mode: ResourceMode.Create
    }
  }
]
